<template>
  <div class="curr-month-overview">
    <div class="record-title">教师登录及处理情况</div>
    <div class="title-1" style="margin: 20px 0 15px">整体使用情况</div>
    <OverallUsage :dataSource="overallUsageInfo" />
    <div class="title-1" style="margin: 20px 0 15px">优秀标杆班主任</div>
    <div class="excellent-header-tea flex-between">
      <HandleInTime
        title="处理及时班主任"
        :dataSource="handleInTimeData"
        class="header-tea-item"
        style="background-color: #eefcf4"
      />
      <RecordCarefully
        title="记录认真班主任"
        :dataSource="recordCarefullyData"
        class="header-tea-item"
      />
    </div>
    <div style="margin-top: 20px">
      <ActionRecordTable
        ref="actionRecordRef1"
        title="班主任登录及使用情况"
        :url="url1"
        :columns="columns1"
      />
    </div>
    <div style="margin-top: 20px">
      <ActionRecordTable
        ref="actionRecordRef2"
        title="处理率较低班级"
        :url="url2"
        :columns="columns2"
      />
    </div>
  </div>
</template>
<script>
import CountAnimation from '@/components/CountAnimation'
import TableList from '@comp/chart/TableList.vue'
import OverallUsage from './components/OverallUsage.vue'
import HandleInTime from './components/HandleInTime.vue'
import RecordCarefully from './components/RecordCarefully.vue'
import ActionRecordTable from './components/ActionRecordTable.vue'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { queryAllDealClassTopThree, queryExcellentDealClassTopThree } from '@/api/monthReport'

export default {
  name: 'TeacherUseData',
  mixins: [JeecgListMixin],
  components: {
    CountAnimation,
    TableList,
    OverallUsage,
    HandleInTime,
    RecordCarefully,
    ActionRecordTable,
  },
  props: {
    dateRange: {
      type: Object,
      default: () => ({}),
    },
    overallUsageInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      handleInTimeData: [],
      recordCarefullyData: [],
      // 有提醒名单但未登录使用班级列表
      url1: {
        list: '/emotionalReport/getTeacherAccessStats',
      },
      // 有提醒名单但未处理班级列表
      url2: {
        list: '/emotionalReport/getLowDealRateClasses',
      },
      columns1: [
        {
          title: '班级',
          dataIndex: 'className',
          align: 'left',
          width:'27.5%'
        },
        {
          title: '教师姓名',
          dataIndex: 'teacherName',
          align: 'left',
          width:'27.5%'
        },
        {
          title: '访问次数',
          dataIndex: 'visitCnt',
          align: 'left',
          width:'9%'
        },
        {
          title: '总提醒数',
          dataIndex: 'totalWarnCnt',
          align: 'left',
          width:'9%'
        },
        {
          title: '已处理数',
          dataIndex: 'dealWarnCnt',
          align: 'left',
          width:'9%'
        },
        {
          title: '未处理数',
          dataIndex: 'unDealWarnCnt',
          align: 'left',
          width:'9%'
        },
        {
          title: '处理率',
          dataIndex: 'dealRate',
          width:'9%',
          align: 'left',
          customRender: (_, record) => {
            const rate = parseFloat(record.dealRate) || 0
            return <a-tag color={rate < 50 ? 'red' : 'green'}>{record.dealRate}</a-tag>
          },
        },
      ],
      columns2: [
        {
          title: '班级',
          dataIndex: 'className',
          align: 'left',
          width:'27.5%'
        },
        {
          title: '教师姓名',
          dataIndex: 'teacherName',
          align: 'left',
          width:'27.5%'
        },
        {
          title: '访问次数',
          dataIndex: 'visitCnt',
          align: 'left',
          width:'15%'
        },
        {
          title: '已处理数',
          dataIndex: 'dealWarnCnt',
          align: 'left',
          width:'10%'
        },
        {
          title: '未处理数',
          dataIndex: 'unDealWarnCnt',
          align: 'left',
          width:'10%'
        },
        {
          title: '处理率',
          dataIndex: 'dealRate',
          align: 'left',
          width:'10%',
          customRender: (_, record) => {
            const rate = parseFloat(record.dealRate) || 0
            return <a-tag color={rate < 50 ? 'red' : 'green'}>{record.dealRate}</a-tag>
          },
        },
      ],
    }
  },
  watch: {
    dateRange(dateObj) {
      this.queryParam = {
        startTime: dateObj.beginDate,
        endTime: dateObj.endDate,
      }
      this.queryAllDealClassTopThree()
      this.queryExcellentDealClassTopThree()
      this.$refs.actionRecordRef1.getLoadData(this.queryParam)
      this.$refs.actionRecordRef2.getLoadData(this.queryParam)
    },
  },
  methods: {
    async queryAllDealClassTopThree() {
      const { success, result } = await queryAllDealClassTopThree(this.queryParam)
      if (success) {
        this.handleInTimeData = result
      }
    },
    async queryExcellentDealClassTopThree() {
      const { success, result } = await queryExcellentDealClassTopThree(this.queryParam)
      if (success) {
        this.recordCarefullyData = result
      }
    },
  },
}
</script>
<style scoped lang="less">
.curr-month-overview {
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  .excellent-header-tea {
    align-items: flex-start !important;
    .header-tea-item {
      width: calc(50% - 15px);
    }
  }
}
</style>
